// extracted by mini-css-extract-plugin
export default {"appointmentWrapper":"createPostForm_appointmentWrapper__es+v+","select":"createPostForm_select__-sNwX","saveButton":"createPostForm_saveButton__BfX-a"};